<template>
    <VueFinalModal
        class="d-flex align-items-center justify-content-center"
        content-class="reset-color-container"
        v-model="modalVisible"
        :click-to-close="false"
        :esc-to-close="false"
    >
        <div class="modal-body__title">Jaarovergang vereist</div>
        <div class="modal-body__content">
            <p><strong>Let op!</strong> De jaarovergang is nog niet uitgevoerd voor dit schooljaar. Alles wat je nu aanpast in het basisrooster wordt niet toegepast op het basisrooster van komend jaar.</p>
        </div>
        <div class="modal-footer">
            <div class="button-wrapper">
                <button
                    @click="dismissModal"
                    class="btn btn-primary btn-sm"
                >
                    Ik begrijp het
                </button>
            </div>
        </div>
    </VueFinalModal>
</template>

<script setup lang="ts">
import { useStore } from '@/composables/useStore'
import { computed, onMounted, ref, watch } from 'vue'
import { VueFinalModal } from 'vue-final-modal'

const { settingsStore } = useStore()

const modalVisible = ref(false)

const SESSION_KEY = 'yearTransitionModalDismissed'

const shouldShowModal = computed(() => {
    const school = settingsStore.getters.value.schoolInfo
    const isDismissedInSession = sessionStorage.getItem(SESSION_KEY) === 'true'
    return !!(school && school.naam && school.jaarOvergangUitgevoerd === false && !isDismissedInSession)
})

watch(
    shouldShowModal,
    (newValue) => {
        modalVisible.value = newValue
    },
    { immediate: true }
)

const dismissModal = () => {
    modalVisible.value = false
    sessionStorage.setItem(SESSION_KEY, 'true')
}

onMounted(() => {
    settingsStore.actions.getSchool()
})
</script>
